import React, { useEffect, useState } from "react";
import { withNamespaces } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";
import filter from "../../images/filter.svg";
import edit from "../../images/edit-btn.svg";
import delte from "../../images/delete-btn.svg";
import empsales from "../../images/emp-sales-sector.png";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import {
  deletejobPostion,
  jobPostiondetailsview,
  jobPostionGetByid,
} from "../../Api/services/org-StructureService";
import CustomModal from "../../components/CustomModal";
import AddJobPosition from "./AddJobPosition";
import Filter from "./Filter";
import Drawer from "../../components/Drawer";
import Spinner from "../../components/Spinner";
import { IoClose } from "react-icons/io5";

function SaleSectorDetails({ t }) {
  const dispatch = useDispatch();
  const { id } = useParams();
  const {
    loading,
    jobpostionloaidng,
    jobPostionDetailLoader,
    jobPositionSingledata,
  } = useSelector((state) => state?.orgStructure);
  const navigate = useNavigate();
  const [openJobModel, setOpenJobModel] = useState(false);
  const [isOpenDrawer, setIsOpenDrawer] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState("");
  //filter open
  const openDrawer = () => {
    setIsOpenDrawer(true);
  };
  //close
  const closeDrawer = () => {
    setIsOpenDrawer(false);
  };
  //open job postion model
  const openjobModal = () => {
    setOpenJobModel(true);
  };
  //close model
  const closejobModel = () => {
    setOpenJobModel(false);
  };
  //location filter get id
  const handleChange = (selectedOption) => {
    setSelectedLocation(selectedOption);
  };
  //delete job postions
  const handelChnagedeletejobpostions = () => {
    Swal.fire({
      title: t("deleteConfirmation.title"),
      text: t("deleteConfirmation.text"),
      icon: t("deleteConfirmation.icon"),
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: t("deleteConfirmation.confirmButtonText"),
    }).then(async (result) => {
      if (result.isConfirmed) {
        const result = await dispatch(deletejobPostion(id));

        if (result?.payload && result?.payload?.success === true) {
          navigate(-1);
        }
      }
    });
  };

  // const totallocationJobSeats = saleSectoreData.data.unit_location_details.reduce(
  //   (total, item) =>
  //     total +
  //     item.location.job_positions.reduce((sum, pos) => sum + pos.minimum_number_of_employees, 0),
  //   0
  // );

  // const totalLocationjobEmployees = saleSectoreData.data.unit_location_details.reduce(
  //   (total, item) =>
  //     total +
  //     item.location.job_positions.reduce((sum, pos) => sum + pos.allocated_number_of_employees, 0),
  //   0
  // );

  // const totalLocationjobEmptySeats = saleSectoreData.data.unit_location_details.reduce(
  //   (total, item) =>
  //     total +
  //     item.location.job_positions.reduce(
  //       (sum, pos) => sum + (pos.minimum_number_of_employees - pos.allocated_number_of_employees),
  //       0
  //     ),
  //   0
  // );
  //call when submit the filter
  const onSubmitFilter = async () => {
    console.log(selectedLocation, "selectedlocations");
    const data = {
      location_id: selectedLocation?.value,
    };
    // setIsOpenDrawer(false);
    //call get api
    const result = await dispatch(
      jobPostiondetailsview({ id: id, data: data })
    );
    if (result?.payload && result.payload.success === true) {
      setIsOpenDrawer(false);
    }
  };

  useEffect(() => {
    dispatch(jobPostiondetailsview({ id: id, data: "" }));
  }, [id]);
  if (jobPostionDetailLoader) {
    return <Spinner size="md" color="#C77025" />;
  }
  //total job locations postion data
  const totallocationJobSeats =
    jobPositionSingledata?.data?.job_positions?.reduce(
      (total, item) => total + item.minimum_number_of_employees,
      0
    );
  const totalLocationjobEmployees =
    jobPositionSingledata?.data?.job_positions?.reduce(
      (total, item) => total + item.allocated_number_of_employees,
      0
    );
  const totalLocationjobEmptySeats =
    jobPositionSingledata?.data?.job_positions?.reduce(
      (total, item) =>
        total +
        (item.minimum_number_of_employees - item.allocated_number_of_employees),
      0
    );

  //calculate unit job data
  if (
    jobPositionSingledata &&
    jobPositionSingledata.data &&
    Array.isArray(jobPositionSingledata.data.units) &&
    jobPositionSingledata.data.units.length > 0 &&
    Array.isArray(jobPositionSingledata.data.units[0].job_positions)
  ) {
    var totalSubjobEmptySeats = 0;
    var totalSubjobEmployees = 0;
    var totalSubJobSeats = 0;

    totalSubJobSeats +=
      jobPositionSingledata?.data?.units[0]?.job_positions?.reduce(
        (sum, item) => sum + item?.minimum_number_of_employees,
        0
      );
    totalSubjobEmployees +=
      jobPositionSingledata?.data?.units[0]?.job_positions?.reduce(
        (sum, item) => sum + item?.allocated_number_of_employees,
        0
      );
    totalSubjobEmptySeats +=
      jobPositionSingledata?.data?.units[0]?.job_positions?.reduce(
        (sum, item) =>
          sum +
          (item?.minimum_number_of_employees -
            item?.allocated_number_of_employees),
        0
      );
  }
  //calculated
  const groupedData = jobPositionSingledata?.data?.job_positions?.reduce(
    (acc, item) => {
      if (!acc[item.location_id]) {
        acc[item.location_id] = {
          location_name: item.location_name,
          totalSeats: 0,
          totalEmployees: 0,
          totalEmptySeats: 0,
          totalJobPositions: 0,
        };
      }

      acc[item.location_id].totalSeats += item.allocated_number_of_employees;
      acc[item.location_id].totalEmployees +=
        item.allocated_number_of_employees;
      acc[item.location_id].totalEmptySeats +=
        item.minimum_number_of_employees - item.allocated_number_of_employees;
      acc[item.location_id].totalJobPositions += 1;

      return acc;
    },
    {}
  );
  //clear filter
  const clearFilter = () => {
    setSelectedLocation("");
    const data = {
      location_id: "",
    };
    dispatch(jobPostiondetailsview({ id: id, data: data }));
  };

  return (
    <div className=" lg:pt-5 lg:pr-5 pt-3 pr-3  overflow-auto">
      <div className=" bg-white rounded-[14px] py-3 px-7 border border-gray_100 mb-6">
        <div className="flex flex-wrap xl:flex-nowrap xl:gap-0 gap-8 justify-between mb-5">
          <div className="flex flex-col mt-5">
            <div className="flex flex-wrap xl:flex-nowrap xl:gap-0 gap-3 w-full mb-5">
              <div className="mr-5 flex flex-col justify-between w-[130px]">
                <h6 className="text-gray_900 font-medium text-sm mb-[14px]">
                  {t("common_detailpages_lables.Abbreviation")}
                </h6>
                <span className="mb-3 text-gray_900 text-sm font-light ">
                  {jobPositionSingledata?.data?.abbreviation}
                </span>
              </div>
              <div className="mr-5 flex flex-col justify-between w-[130px]">
                <h6 className=" text-gray_900 font-medium text-sm mb-[14px]">
                  {t("common_detailpages_lables.Title")}
                </h6>
                <span className="mb-3 text-gray_900 text-sm font-light ">
                  {jobPositionSingledata?.data?.name}
                </span>
              </div>
              <div className="mr-5 flex flex-col justify-between w-[130px]">
                <h6 className=" text-gray_900 font-medium text-sm mb-[14px]">
                  {" "}
                  {t("common_detailpages_lables.noOfSeats")}
                </h6>
                <span className="mb-3 text-gray_900 text-sm font-light ">
                  {jobPositionSingledata?.data?.allocated_number_of_employees}
                </span>
              </div>
              <div className="mr-5 flex flex-col justify-between w-[130px]">
                <h6 className=" text-gray_900 font-medium text-sm mb-[14px]">
                  {t("common_detailpages_lables.language_requirements")}
                </h6>
                <span className="mb-3 text-gray_900 text-sm font-light ">
                  {" "}
                  {jobPositionSingledata?.data?.foreign_language_name !== ""
                    ? jobPositionSingledata?.data?.foreign_language_name
                    : "- / -"}
                </span>
              </div>
              <div className="mr-5 flex flex-col justify-between w-[130px]">
                <h6 className=" text-gray_900 font-medium text-sm mb-[14px]">
                  {" "}
                  {t("common_detailpages_lables.years_of_experience")}
                </h6>
                <span className="mb-3 text-gray_900 text-sm font-light ">
                  {" "}
                  {jobPositionSingledata?.data?.work_experience}
                </span>
              </div>
              <div className="mr-5 flex flex-col justify-between w-[130px]">
                <h6 className=" text-gray_900 font-medium text-sm mb-[14px]">
                  {" "}
                  {t("common_detailpages_lables.Locations")}
                </h6>
                <span className="mb-3 text-gray_900 text-sm font-light ">
                  {jobPositionSingledata?.data?.location_name}
                </span>
              </div>
            </div>
            <div className="flex flex-wrap xl:flex-nowrap xl:gap-0 gap-3 w-full mb-5">
              <div className="mr-5 flex flex-col justify-between w-[130px]">
                <h6 className=" text-gray_900 font-medium text-sm mb-[14px]">
                  {" "}
                  {t("common_detailpages_lables.serial_number")}
                </h6>
                <span className="mb-3 text-gray_900 text-sm font-light ">
                  {" "}
                  {jobPositionSingledata?.data?.system_id}
                </span>
              </div>
              <div className="mr-5 flex flex-col justify-between w-[130px]">
                <h6 className=" text-gray_900 font-medium text-sm mb-[14px]">
                  {" "}
                  {t("common_detailpages_lables.organzations_unit")}
                </h6>
                <span
                  className=" mb-0 text-primary_orange underline  font-semibold text-sm cursor-pointer"
                  onClick={() =>
                    navigate(
                      `/organizational-structure/unit-details/${jobPositionSingledata?.data?.unit_id}?name=${jobPositionSingledata?.data?.unit_name}`
                    )
                  }
                >
                  {jobPositionSingledata?.data?.unit_name}
                </span>
              </div>
              <div className="mr-5 flex flex-col justify-between w-[130px]">
                <h6 className="text-gray_900 font-medium text-sm mb-[14px]">
                  {t("common_detailpages_lables.Min_executors")}
                </h6>
                <span className="mb-3 text-gray_900 text-sm font-light ">
                  {jobPositionSingledata?.data?.minimum_number_of_employees}
                </span>
              </div>
              <div className="mr-5 flex flex-col justify-between w-[130px]">
                <h6 className=" text-gray_900 font-medium text-sm mb-[14px]">
                  {t("common_detailpages_lables.educational_qualifications")}
                </h6>
                <span className="mb-3 text-gray_900 text-sm font-light flex flex-col justify-between w-[130px]">
                  {jobPositionSingledata?.data?.educational_qualification_name}
                </span>
              </div>
              <div className="mr-5 flex flex-col justify-between w-[130px]">
                <h6 className="text-gray_900 font-medium text-sm mb-[14px]">
                  {" "}
                  {t("common_detailpages_lables.coefficient")}
                </h6>
                <span className="mb-3 text-gray_900 text-sm font-light ">
                  {" "}
                  {jobPositionSingledata?.data?.difficulty_coefficient}
                </span>
              </div>
            </div>
          </div>
          <div className="flex items-start justify-end w-full mt-5">
            <div className="">
              {selectedLocation?.label && (
                <button className=" flex items-center bg-primary_transparent border border-gray_100  py-1 px-[10px] rounded-[10px] text-gray_600 text-sm font-light mr-3">
                  {selectedLocation?.label}{" "}
                  <IoClose className=" ml-8" onClick={clearFilter} />
                </button>
              )}
            </div>
            <div className="mr-[10px]">
              <Link onClick={openDrawer}>
                {" "}
                <img src={filter} alt=" filter" />
              </Link>
            </div>
            <div className="mr-[10px]">
              <Link onClick={openjobModal}>
                {" "}
                <img src={edit} alt=" edit" />{" "}
              </Link>
            </div>
            <div>
              <Link onClick={handelChnagedeletejobpostions}>
                {" "}
                {/* <img src={delte} alt=" delte" />{" "} */}
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_3810_24486)">
                    <path
                      d="M3.66602 6.41699H18.3327"
                      stroke="#780408"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M4.58398 6.41699L5.50065 17.417C5.50065 17.9032 5.69381 18.3695 6.03762 18.7134C6.38144 19.0572 6.84775 19.2503 7.33398 19.2503H14.6673C15.1535 19.2503 15.6199 19.0572 15.9637 18.7134C16.3075 18.3695 16.5006 17.9032 16.5006 17.417L17.4173 6.41699"
                      stroke="#780408"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M8.25 6.41667V3.66667C8.25 3.42355 8.34658 3.19039 8.51849 3.01849C8.69039 2.84658 8.92355 2.75 9.16667 2.75H12.8333C13.0764 2.75 13.3096 2.84658 13.4815 3.01849C13.6534 3.19039 13.75 3.42355 13.75 3.66667V6.41667"
                      stroke="#780408"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M9.16602 11L12.8327 14.6667M12.8327 11L9.16602 14.6667"
                      stroke="#780408"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_3810_24486">
                      <rect width="22" height="22" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </Link>
            </div>
          </div>
        </div>

        <div className=" flex flex-wrap xl:flex-nowrap ">
          <div className=" mr-5 w-[440px]">
            <h6 className="text-gray_900 font-medium text-sm">
              {t("common_detailpages_lables.mandatory_skills")}
            </h6>
            <p className=" py-3 text-gray_900 text-sm font-light">
              {jobPositionSingledata?.data
                ?.required_knowledge_and_skill_name !== ""
                ? jobPositionSingledata?.data?.required_knowledge_and_skill_name
                : "- / -"}
            </p>
          </div>

          <div className=" mr-5 w-[440px]">
            <h6 className="text-gray_900 font-medium text-sm">
              {" "}
              {t("common_detailpages_lables.Special_requirements")}
            </h6>
            <p className=" py-3 text-gray_900 text-sm font-light">
              {jobPositionSingledata?.data?.special_requirement_name !== ""
                ? jobPositionSingledata?.data?.special_requirement_name
                : "- / -"}
            </p>
          </div>

          <div className=" mr-5 w-full">
            <h6 className="text-gray_900 font-medium text-sm">
              {" "}
              {t("common_detailpages_lables.Job_position_description")}
            </h6>
            <p className=" py-3 text-gray_900 text-sm font-light">
              {jobPositionSingledata?.data?.description}
            </p>

            {/* <span className=" my-2 block text-gray_900 text-sm font-light">
              {json.common_detailpages_lables.Key_responsibilities}
            </span>
            <ul className=" list-disc list-inside">
              <li className=" text-gray_900 text-sm font-light ml-2">
                Leading and motivating the sales team
              </li>
              <li className=" text-gray_900 text-sm font-light ml-2">
                Developing and implementing sales strategies
              </li>
              <li className=" text-gray_900 text-sm font-light ml-2">
                Monitoring and analysis of market trends and competitors
              </li>
              <li className=" text-gray_900 text-sm font-light ml-2">
                Maintaining relationships with key clients
              </li>
              <li className=" text-gray_900 text-sm font-light ml-2">
                Preparation of monthly, quarterly and annual reports
              </li>
              <li className=" text-gray_900 text-sm font-light ml-2">
                Participation in the recruitment and training of new team members
              </li>
            </ul> */}
          </div>
        </div>
      </div>

      <div className=" bg-white_50 rounded-[14px] border border-gray_50 p-5 overflow-x-auto text-nowrap">
        <h5 className=" mb-5 text-lg text-gray_900 font-normal">Employees</h5>
        {/* <div className=" flex mb-3">
          <div className=" flex items-center mr-5 p-[10px] ">
            <h6 className=" text-primary_orange  font-bold text-sm mr-[10px]">Marko Marković</h6>
            <img src={empsales} alt="empsales" />
          </div>

          <div className=" flex items-center mr-5 p-[10px] ">
            <h6 className="  text-gray_900 font-medium text-sm  mr-[10px]">Job position:</h6>
            <Link to="/" className="text-primary_orange  font-bold text-sm mr-[10px] underline">
              Sales manager
            </Link>
          </div>

          <div className=" flex items-center mr-5 p-[10px] ">
            <h6 className="  text-gray_900 font-medium text-sm  mr-[10px]">Superior JP:</h6>
            <Link to="/" className="text-primary_orange  font-bold text-sm mr-[10px] underline">
              Executive Director
            </Link>
          </div>

          <div className=" flex items-center mr-5 p-[10px] ">
            <h6 className="  text-gray_900 font-medium text-sm  mr-[10px]">Location:</h6>
            <span className="text-gray_900  font-light text-sm mr-[10px] ">Office no. 3</span>
          </div>
        </div>
        <div className=" flex mb-3">
          <div className=" flex items-center mr-5 p-[10px] ">
            <h6 className=" text-primary_orange  font-bold text-sm mr-[10px]">Marko Marković</h6>
            <img src={empsales} alt="empsales" />
          </div>

          <div className=" flex items-center mr-5 p-[10px] ">
            <h6 className="  text-gray_900 font-medium text-sm  mr-[10px]">Job position:</h6>
            <Link to="/" className="text-primary_orange  font-bold text-sm mr-[10px] underline">
              Sales manager
            </Link>
          </div>

          <div className=" flex items-center mr-5 p-[10px] ">
            <h6 className="  text-gray_900 font-medium text-sm  mr-[10px]">Superior JP:</h6>
            <Link to="/" className="text-primary_orange  font-bold text-sm mr-[10px] underline">
              Executive Director
            </Link>
          </div>

          <div className=" flex items-center mr-5 p-[10px] ">
            <h6 className="  text-gray_900 font-medium text-sm  mr-[10px]">Location:</h6>
            <span className="text-gray_900  font-light text-sm mr-[10px] ">Office no. 3</span>
          </div>
        </div> */}
        <div>No employee found</div>
        <div className=" border-t border-gray_dark">
          <div className=" flex items-center  p-[10px] ">
            <h6 className="  text-gray_900 font-medium text-sm  mr-[10px]">
              In total:
            </h6>
            <span className="text-gray_900  font-light text-sm mr-[10px] ">
              0
            </span>
          </div>
        </div>
      </div>
      {/* job postion sections */}
      <div className="mt-6 border border-gray_50  bg-white_50 p-5 rounded-[14px] mb-[10px] overflow-x-auto text-nowrap">
        <div className="flex justify-between items-center py-3 mb-5">
          <h5 className=" text-gray_900 font-normal text-lg ">
            {" "}
            {t("common_detailpages_lables.Managing_job_postions")}
          </h5>
          {/* <button>
            {" "}
            <img src={filter} alt="filter" onClick={openDrawer} />{" "}
          </button> */}
        </div>

        <div className="overflow-x-auto">
          <table className="  w-full">
            <tbody>
              {jobPositionSingledata &&
              jobPositionSingledata.data &&
              Array.isArray(jobPositionSingledata.data.units) &&
              jobPositionSingledata.data.units.length > 0 &&
              Array.isArray(
                jobPositionSingledata.data.units[0].job_positions
              ) &&
              jobPositionSingledata.data.units[0].job_positions.length > 0 ? (
                jobPositionSingledata.data.units[0].job_positions.map(
                  (item, index) => {
                    return (
                      <tr className="">
                        <td>
                          {" "}
                          <div className=" mr-5 w-full max-w-[250px] lg:min-w-0 min-w-[150px] mb-5">
                            <p
                              className=" mb-0 text-primary_orange underline  font-semibold text-sm cursor-pointer"
                              onClick={() =>
                                navigate(
                                  `/organizational-structure/job-details/${item?.id}?name=${item.name}`
                                )
                              }
                            >
                              {item?.name}
                            </p>
                          </div>
                        </td>
                        <td>
                          {" "}
                          <div className="mr-5 flex w-full max-w-[140px] lg:min-w-0 min-w-[150px] mb-5">
                            <h6 className=" text-gray_900 font-medium text-sm ">
                              {t("common_detailpages_lables.noOfSeats")}
                            </h6>
                            <span className=" text-gray_900 text-sm font-light ml-[10px]">
                              {" "}
                              {item?.minimum_number_of_employees}
                            </span>
                          </div>
                        </td>
                        <td>
                          <div className="mr-5 flex w-full max-w-[140px] lg:min-w-0 min-w-[100px] mb-5 ">
                            <h6 className=" text-gray_900 font-medium text-sm ">
                              {t("common_detailpages_lables.noOfEmployees")}
                            </h6>
                            <span className=" text-gray_900 text-sm font-light ml-[10px]">
                              {" "}
                              {/* {item?.allocated_number_of_employees} */}
                              {0}
                            </span>
                          </div>
                        </td>
                        <td>
                          <div className="mr-5 flex w-full  max-w-[140px] lg:min-w-0 min-w-[100px] mb-5">
                            <h6 className=" text-gray_900 font-medium text-sm ">
                              {t("common_detailpages_lables.emptySeats")}
                            </h6>
                            <span className=" text-gray_900 text-sm font-light ml-[10px]">
                              {" "}
                              {/* {item?.minimum_number_of_employees -
                              item?.allocated_number_of_employees} */}
                              {item?.minimum_number_of_employees - 0}
                            </span>
                          </div>
                        </td>
                        <td>
                          <div className="mr-5 flex w-full max-w-[140px] mb-5">
                            <h6 className=" text-gray_900 font-medium text-sm ">
                              {t("common_detailpages_lables.serial_number")}
                            </h6>
                            <span className=" text-gray_900 text-sm font-light ml-[10px]">
                              {" "}
                              {item?.system_id}
                            </span>
                          </div>
                        </td>
                        <td>
                          <div className="mr-5 flex w-full max-w-[140px] mb-5">
                            <h6 className=" text-gray_900 font-medium text-sm ">
                              {t("common_detailpages_lables.Locations")}
                            </h6>
                            <span className=" text-gray_900 text-sm font-light ml-[10px]">
                              {item?.location || "-"}
                            </span>
                          </div>
                        </td>
                      </tr>
                    );
                  }
                )
              ) : (
                <p> {t("common_detailpages_lables.no_job_postions")}</p>
              )}

              <tr className=" border-t border-gray_dark ">
                <td></td>
                <td>
                  <div className="mr-5 flex w-full max-w-[140px] lg:min-w-0 min-w-[150px] mt-4 ">
                    <h6 className=" text-gray_900 font-medium text-sm ">
                      {" "}
                      {t("common_detailpages_lables.total_no_of_seats")}
                    </h6>
                    <span className=" text-gray_900 text-sm font-light ml-[10px]">
                      {totalSubJobSeats}
                    </span>
                  </div>
                </td>
                <td>
                  <div className="mr-5 flex w-full max-w-[140px] lg:min-w-0 min-w-[150px] mt-4 ">
                    <h6 className=" text-gray_900 font-medium text-sm ">
                      {" "}
                      {t("common_detailpages_lables.total_employees")}
                    </h6>
                    <span className=" text-gray_900 text-sm font-light ml-[10px]">
                      {/* {totalSubjobEmployees} */}
                      {0}
                    </span>
                  </div>
                </td>
                <td>
                  <div className="mr-5 flex w-full max-w-[140px] lg:min-w-0 min-w-[150px] mt-4 ">
                    <h6 className=" text-gray_900 font-medium text-sm ">
                      {" "}
                      {t("common_detailpages_lables.total_empty_seats")}
                    </h6>
                    <span className=" text-gray_900 text-sm font-light ml-[10px]">
                      {/* {totalSubjobEmptySeats} */} {totalSubJobSeats}
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      {/* locations sections */}
      <div className="mt-6 border border-gray_50  bg-white_50 p-5 rounded-[14px] mb-[10px] overflow-x-auto text-nowrap">
        <div className="flex justify-between items-center py-3 mb-5">
          <h5 className=" text-gray_900 font-normal text-lg ">
            {" "}
            {t("common_detailpages_lables.Locations")}
          </h5>
          {/* <button>
            {" "}
            <img src={filter} alt="filter" onClick={openDrawer} />{" "}
          </button> */}
        </div>

        <div className="overflow-x-auto">
          <table className=" w-full">
            <tbody>
              {groupedData &&
              Object.keys(groupedData).length > 0 &&
              Object?.keys(groupedData)?.length > 0 ? (
                Object?.values(groupedData)?.map((location, index) => (
                  <tr key={index}>
                    <td>
                      <div className="mr-5 w-full max-w-[250px] lg:min-w-0 min-w-[150px] mb-5">
                        <p
                          className="mb-0 text-primary_orange underline font-semibold text-sm cursor-pointer"
                          onClick={() =>
                            navigate(
                              `/admin/locations/details/${jobPositionSingledata?.data?.location_id}`
                            )
                          }
                        >
                          {jobPositionSingledata?.data?.location_name}
                        </p>
                      </div>
                    </td>
                    <td>
                      <div className="mr-5 flex w-full max-w-[140px] lg:min-w-0 min-w-[150px] mb-5">
                        <h6 className="text-gray_900 font-medium text-sm">
                          {t("common_detailpages_lables.noOfSeats")}
                        </h6>
                        <span className="text-gray_900 text-sm font-light ml-[10px]">
                          {location.totalSeats}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div className="mr-5 flex w-full max-w-[140px] lg:min-w-0 min-w-[100px] mb-5">
                        <h6 className="text-gray_900 font-medium text-sm">
                          {t("common_detailpages_lables.noOfEmployees")}
                        </h6>
                        <span className="text-gray_900 text-sm font-light ml-[10px]">
                          {/* {location.totalEmployees} */}
                          {0}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div className="mr-5 flex w-full max-w-[140px] lg:min-w-0 min-w-[100px] mb-5">
                        <h6 className="text-gray_900 font-medium text-sm">
                          {t("common_detailpages_lables.emptySeats")}
                        </h6>
                        <span className="text-gray_900 text-sm font-light ml-[10px]">
                          {location.totalSeats}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div className="mr-5 flex w-full max-w-[140px] mb-5">
                        <h6 className="text-gray_900 font-medium text-sm">
                          {t("common_detailpages_lables.noOfJobPositions")}
                        </h6>
                        <span className="text-gray_900 text-sm font-light ml-[10px]">
                          {location.totalJobPositions}
                        </span>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <p>{t("common_detailpages_lables.no_location_found")}</p>
              )}

              <tr className="border-t border-gray_dark">
                <td></td>
                <td>
                  <div className="mr-5 flex w-full max-w-[140px] lg:min-w-0 min-w-[150px] mt-4">
                    <h6 className="text-gray_900 font-medium text-sm">
                      {t("common_detailpages_lables.total_no_of_seats")}
                    </h6>
                    <span className="text-gray_900 text-sm font-light ml-[10px]">
                      {totallocationJobSeats}
                    </span>
                  </div>
                </td>
                <td>
                  <div className="mr-5 flex w-full max-w-[140px] lg:min-w-0 min-w-[150px] mt-4">
                    <h6 className="text-gray_900 font-medium text-sm">
                      {t("common_detailpages_lables.total_employees")}
                    </h6>
                    <span className="text-gray_900 text-sm font-light ml-[10px]">
                      {/* {totalLocationjobEmployees} */}
                      {0}
                    </span>
                  </div>
                </td>
                <td>
                  <div className="mr-5 flex w-full max-w-[140px] lg:min-w-0 min-w-[150px] mt-4">
                    <h6 className="text-gray_900 font-medium text-sm">
                      {t("common_detailpages_lables.total_empty_seats")}
                    </h6>
                    <span className="text-gray_900 text-sm font-light ml-[10px]">
                      {totallocationJobSeats}
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {openJobModel && (
        <CustomModal
          isOpen={openJobModel}
          onClose={closejobModel}
          style={{ content: { height: "" } }}
          title={t("organizations.modalTitles.edit_job_postions")}
        >
          {/* Your modal content goes here */}
          <React.Fragment>
            {/* call unit componnents */}
            <AddJobPosition
              onClose={closejobModel}
              editmode={true}
              jobPostionId={id}
            />
          </React.Fragment>
          {/* Add your form or content for editing here */}
        </CustomModal>
      )}
      <Drawer drawerId="myDrawer" isOpen={isOpenDrawer} openDrawer={openDrawer}>
        <Filter
          closeDrawer={closeDrawer}
          handleChange={handleChange}
          selectedLocation={selectedLocation}
          submitFilter={onSubmitFilter}
        />
      </Drawer>
    </div>
  );
}

export default withNamespaces()(SaleSectorDetails);
